import { fetchAllCompanyTypesApi, fetchAllRolesApi, fetchAllStatesApi } from '../api/common.api';
import {
  getAllCompanyTypesStart,
  getAllCompanyTypesSuccess,
  getAllCompanyTypesFailure,
} from './companyType.slice';
import { getAllStatesStart, getAllStatesSuccess, getAllStatesFailure } from './state.slice';
import { getAllRolesStart, getAllRolesSuccess, getAllRolesFailure } from './role.slice';

const fetchAllCompanyTypes = () => async (dispatch) => {
  dispatch(getAllCompanyTypesStart());
  try {
    const response = await fetchAllCompanyTypesApi();
    dispatch(getAllCompanyTypesSuccess(response.data));
  } catch (error) {
    dispatch(getAllCompanyTypesFailure(error.response.data));
  }
};

const fetchAllStates = () => async (dispatch) => {
  dispatch(getAllStatesStart());
  try {
    const response = await fetchAllStatesApi();
    dispatch(getAllStatesSuccess(response.data));
  } catch (error) {
    dispatch(getAllStatesFailure(error.response.data));
  }
};

const fetchAllRoles = () => async (dispatch) => {
  dispatch(getAllRolesStart());
  try {
    const response = await fetchAllRolesApi();
    dispatch(getAllRolesSuccess(response.data));
  } catch (error) {
    dispatch(getAllRolesFailure(error.response.data));
  }
};

export { fetchAllCompanyTypes, fetchAllRoles, fetchAllStates };
